import * as THREE from 'three';
function createCube(size, color) {
    const geometry = new THREE.BoxGeometry(size, size, size);
    const material = new THREE.MeshBasicMaterial({ color: color ,transparent:true});
    const cube = new THREE.Mesh(geometry, material);
    return cube;
  }


  

  export {createCube}